export default __webpack_public_path__ + "static/sunchang2-5e40751face2bed91d2be73c907bb7d9.jpg";